import axios from "axios";
import { getRefreshedTokens } from "../services/auth.service";
import { Auth } from "./auth";
import { LOCAL_STORAGE_KEYS, ROUTES } from "../common/constants";
import { isNull } from "underscore";
import { getRefreshedTokensAndUpdateThePreviousTokens } from "../common/utils";

const client = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API_HOST,
  headers: {
    "Content-Type": "application/json",
  },
});

export const client2 = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API_HOST,
  headers: {
    "Content-Type": "application/json",
  },
});

const nonProtectedRoutes = ["login", "/auth/get_gauth_token_from_auth_code/"];

// Add a request interceptor
client.interceptors.request.use(
  function (config) {
    const auth = Auth.getInstance();
    const route = config.url!;
    const loginRoute = route?.split("/");
    const isLoginRoute =
      Array.isArray(loginRoute) &&
      loginRoute?.length > 1 &&
      nonProtectedRoutes.includes(loginRoute[1]);

    const isNonProtectedRoute =
      isLoginRoute || nonProtectedRoutes.includes(route);

    // if a route is non protected route, don't send Authorization header
    if (isNonProtectedRoute) return config;

    const isDataMissingFromLocalStorage = Object.keys(LOCAL_STORAGE_KEYS).some(
      (key) => isNull(localStorage.getItem(key))
    );

    // if some local storage keys go missing, logout of the application
    if (isDataMissingFromLocalStorage) {
      auth.discardSession();
      window.location.replace(ROUTES.login);
      return config;
    }

    const accessToken = auth.getAccessToken() || "";
    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Response interceptor
client.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    const auth = Auth.getInstance();
    const refreshToken = auth.getRefreshToken() || "";

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      // Mark the request as retried to avoid infinite loops.
      originalRequest._retry = true;
      // Handle 401 error, e.g., redirect to login or refresh token
      try {
        // Make a request to auth server to refresh the token.
        const response = await getRefreshedTokens({
          refresh: refreshToken,
        });
        const { access: newAccessToken, refresh: newRefreshToken } =
          response.data;
        // Store the new access and refresh tokens.
        auth.saveAccessToken(newAccessToken);
        auth.saveRefreshToken(newRefreshToken);

        // Update the google access and refresh tokens as well, needed for drivepicker
        await getRefreshedTokensAndUpdateThePreviousTokens();

        // Update the authorization header with the new access token.
        client.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${newAccessToken}`;
        // Retry the original request with the new access token.
        return client(originalRequest);
      } catch (error) {
        auth.discardSession();
        window.location.replace(ROUTES.login);
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default client;
